import { Button, VStack, Text } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { ModalAiSubStillActiveVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalAiSubStillActiveVariantProps;

export const AiSubActiveModal = ({ handleClose, isShown, endDate }: Props): ReactElement => {
  const handleContinue = (): void => {
    handleClose();
  };
  return (
    <CustomModal isOpen={isShown} onClose={handleClose} placement="center" hideHeader size="md">
      <CustomModalContent p="30px">
        <VStack gap="30px">
          <VStack gap="15px" alignItems="flex-start">
            <Text textStyle="body.m.medium">
              Dein Novaheal Abonnement läuft noch bis zum {endDate}.
            </Text>
            <Text textStyle="body.m.regular">
              Du hast noch ein aktives AI-Abonnement, das du separat kündigen musst.
            </Text>
          </VStack>

          <Button onClick={handleContinue} variant="primary" w="full">
            Weiter
          </Button>
        </VStack>
      </CustomModalContent>
    </CustomModal>
  );
};
